module.exports = __webpack_public_path__ + "static/key-supraland-7f7ff78da190a231f63a78fcc15ef23b.webp";